<style lang="scss">

</style>

<template>
  <!-- eslint-disable -->
  <div class="post-search-page mb-4">

    <section class="d-flex full-width justify-content-end">
      <b-button @click="$bvModal.show('modal-add-restriction')" class="btn-success" cy="add-restriction">Apply A Ban</b-button>
    </section>

    <section class="my-2">
      <h4>Filters</h4>

      <div class="row">
        <section class="col-3">
          <label>{{'prisoner' | term(true)}} Number</label>
          <b-form-input
            @keyup.enter="searchRestrictions()"
            v-model="filters.prisonerNumber"
            class="mb-1"
            :placeholder="'Enter ' + $options.filters.term('prisoner') + ' number'"
          />
        </section>

        <section class="col d-flex align-items-center" style="">
          <div class="ui-spacer"></div>
          <b-button class="btn-success ml-1" @click="searchRestrictions()">Search</b-button>
        </section>
      </div>
    </section>

    <b-card no-body class="mb-0">
      <section>
        <b-table
          class="data-table"
          :items="restrictions"
          :fields="headers"
          :current-page="currentPage"
          :per-page="0"
        >
          <template #cell(created_at)="data">
            {{data.item.created_at | formatDateTime}}
          </template>

          <template #cell(actions)="data">
            <b-btn
              @click="showRestrictionModal(data.item, 'modal-delete-restriction')"
              variant="danger"
              class="">
              Remove
            </b-btn>
          </template>
        </b-table>
        <b-row class="p-1">
          <b-col md="6" class="m-1" v-if="totalRows > filters.limit">
            <b-pagination :total-rows="totalRows" :per-page="filters.limit" v-model="currentPage" class="my-0"/>
          </b-col>
          <p v-if="totalRows === 0" class="col-6 ml-2 my-1">No prisoner bans to show</p>
        </b-row>
      </section>
    </b-card>

    <b-modal id="modal-add-restriction" title="Applying A Ban" hide-footer>
      <create-digital-mail-restriction @refresh="getRestrictions()" @close="closeModals()"/>
    </b-modal>
    <b-modal id="modal-delete-restriction" title="Remove A Ban" hide-footer>
      <delete-modal v-if="selectedRestriction"
                    @close="closeModals()"
                    @delete="deleteRestriction(selectedRestriction)"
                    :subtitle="`${$options.filters.term('prisoner')} #${selectedRestriction.prisoner_number}`"
                    title="Are you sure you want to remove this ban?"
                    :delete-button-text="'Remove'"
      />
    </b-modal>
  </div>
  <!-- eslint-enable -->
</template>

<script>
import DigitalMailRestrictionsService from '../../services/DigitalMailRestrictionsService';
import CreateDigitalMailRestriction from './sections/CreateDigitalMailRestriction.vue';
import DeleteModal from '../../components/modals/DeleteModal.vue';

export default {
  name: 'DigitalRepliesSearch',
  components: {
    CreateDigitalMailRestriction,
    DeleteModal,
  },
  data() {
    return {
      filters: {
        prisonerNumber: '',
        skip: 1,
        limit: 10,
      },
      loading: true,
      headers: [
        { label: `${this.$options.filters.term('prisoner')} Number`, key: 'prisoner_number' },
        { label: 'Reason', key: 'reason' },
        { label: 'Date', key: 'created_at' },
        { label: '', key: 'actions' },
      ],
      restrictions: [],
      selectedRestriction: null,
      currentPage: 1,
      totalRows: 10,
    };
  },
  watch: {
    currentPage() {
      this.getRestrictions();
    },
  },
  mounted() {
    this.getRestrictions();
  },
  methods: {
    closeModals() {
      this.$bvModal.hide('modal-add-restriction');
      this.$bvModal.hide('modal-delete-restriction');
    },
    showRestrictionModal(restriction, modalName) {
      this.selectedRestriction = restriction
      this.$bvModal.show(modalName)
    },
    searchRestrictions() {
      this.currentPage = 1;
      this.getRestrictions();
    },
    getRestrictions() {
      this.closeModals()
      this.filters.skip = (this.currentPage - 1) * this.filters.limit

      DigitalMailRestrictionsService.list(this.filters).then(res => {
        this.loading = false;
        this.restrictions = res.data.data;
        this.totalRows = res.data.count;
      }).catch(err => {
        console.log('Error getting prisoner bans: ', err);
        this.$toast.error('Could not get prisoner bans, please refresh and try again', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      });
    },
    deleteRestriction(restriction) {
      this.closeModals()

      DigitalMailRestrictionsService.delete(restriction._id).then(() => {
        this.$toast.success('Removed prisoner ban successfully', {
          toastClassName: ['toast-std', 'success-toast'],
        });

        this.getRestrictions()
      }).catch(err => {
        console.log('Error removing prisoner ban: ', err);
        this.$toast.error('Something went wrong removing the prisoner ban. please refresh and try again', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      })
    },
  },
};
</script>
